import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";
import useUser from "../auth/useUser";
import useTenantUsers from "../tenantUsers/useTenantUsers";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import WorkspaceAPI from "../../api/WorkspaceAPI";
import { handleWorkspaceResponse } from "../../../utils/WorkspaceUtils";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { Workspace } from "../../../types/WorkspaceInterfaces";

const useWorkspace = () => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const { users, usersLoading } = useTenantUsers();
  const { user, wPermissions: workspacePermissions } = useUser();

  const enabled =
    queriesEnabled &&
    !!workspaceID &&
    workspaceID !== "None" &&
    !!user &&
    !usersLoading;

  const workspace = useQuery({
    queryKey: ["workspace", workspaceID],
    queryFn: () =>
      WorkspaceAPI.getWorkspaceByID(workspaceID).then((data) => {
        const result = handleWorkspaceResponse(
          data.data.data.workspace,
          workspaceID,
          workspacePermissions,
          users,
          user,
          data.data.httpStatus
        );

        return result as any;
      }),
    enabled,
  });

  return {
    workspace: workspace.data?.workspace as Workspace,
    workspaceMembers: workspace.data?.workspaceMembers,
    workspaceData: workspace.data?.workspaceData,
    partialAccess: workspace.data?.partialAccess,
    workspaceLoading:
      workspace.isLoading ||
      (!enabled && queriesEnabled) ||
      workspaceID === null,
    workspaceError: workspace.error
      ? {
          status: (workspace.error as any)?.response?.status,
          message: getErrorMessage(workspace.error),
        }
      : null,
    enabled: enabled,
  };
};

export default useWorkspace;
